import request from '../../shared/request'

export function fetchAll() {
  return request('v1/services/selos')
}
